<template>
  <span
    class="text-[14px] font-normal leading-[14px] text-[#DC2828]"
    data-toggle="tooltip"
    title="Delete"
    :disabled="deleteLoading"
    @click.prevent="onDeleteClick"
  >
    Delete order
  </span>
</template>

<script>
export default {
  name: "DeletePurchaseOrder",
  props: ["purchaseOrder", "userType"],

  data() {
    return {
      deleteLoading: false,
    };
  },

  methods: {
    onDeleteClick() {
      this.$emit("showAction", {
        purchaseNumber: this.purchaseOrder.orderNumber,
        action: "delete",
        owner: this.purchaseOrder.id,
      });
    },

    async deletePurchaseOrder() {
      this.deleteLoading = true;
      this.isBusy = true;
      try {
        if (this.userType === "salesAgent") {
          const response = await this.$http.delete(
            "/PurchaseOrders/salesAgentdelete/" + this.purchaseOrder.id
          );
          if (response.ok && response.status === 200) this.$emit("onComplete");
        } else {
          const response = await this.$http.delete(
            "/PurchaseOrders/delete/" + this.purchaseOrder.id
          );
          if (response.ok && response.status === 200) this.$emit("onComplete");
        }
        this.$toast.success("Purchase order deleted successfully", {
          icon: true,
          rtl: false,
        });
        this.deleteLoading = false;
        this.isBusy = true;
      } catch (error) {
        console.log(err);
        this.deleteLoading = false;
        this.isBusy = true;
      }
    },
  },
};
</script>

<style></style>
